import DefaultHeader from "./default";
import HeaderSeguridade from "./seguridade";

export default { DefaultHeader, HeaderSeguridade };
